import { ChangeDetectionStrategy, Component, Input, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataSummaryStore } from 'src/app/features/questionnaires/store/data-summary-store';
import { filter, map } from 'rxjs';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { StepperComponent } from 'src/app/features/create-questionnaire-page/component/steps-menu/stepper/stepper.component';
import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';
import { EReplyStatus } from 'src/app/models/recipients.model';
import { AnswersStore } from 'src/app/store/answers-store';
import { MiniContactDisplayComponent } from 'src/app/features/users/components/mini-contact-display/mini-contact-display.component';
import { SvgIconComponent } from 'angular-svg-icon';
import { QueDatePipe } from 'src/app/pipes/date.pipe';
import { Question } from 'src/app/models/question.model';

@Component({
    selector: 'que-data-toolbar',
    imports: [CommonModule, TranslateDirective, TranslatePipe, StepperComponent, OverlayModule, MiniContactDisplayComponent, SvgIconComponent, QueDatePipe],
    templateUrl: './data-toolbar.component.html',
    styleUrls: ['./data-toolbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DataToolbarComponent {
  @Input() fromSummary = false;
  #storeData = inject(DataSummaryStore);

  questionsData$ = toSignal(this.#storeData.questionsData$);
  questionnarieDetails$ = toSignal(this.#storeData.questionnarieDetails$);
  showComparison$ = toSignal(this.#storeData.showComparison$);

  filterFieldQuestionsData$ = toSignal(this.#storeData.filterFieldQuestionsData$);
  filterFieldAnswersData$ = toSignal(this.#storeData.filterFieldAnswersData$);
  filterFieldAnswerOptions$ = toSignal(this.#storeData.filterFieldAnswerOptions$);
  selectedFilterFieldValue$ = toSignal(this.#storeData.selectedFilterFieldValue$);
  filterFieldSubmissionOptions$ = toSignal(this.#storeData.filterFieldSubmissionOptions$);
  recipientIdToFilter$ = toSignal(this.#storeData.recipientIdToFilter$);
  selectedFilterSubmissionOption$: any = toSignal(this.#storeData.selectedFilterSubmissionOption$);
  filterByFilterFieldValue(value: string | number | undefined) {
    this.#storeData.updateSelectedFilterFieldValue(value);
    this.isFilterQuestionOpen = false;
  }

  amountAll$ = this.#storeData.recipients$.pipe(map(x => x?.length));
  amountComplete$ = this.#storeData.recipients$.pipe(filter(x => x != undefined), map(x => x!.filter(y => y.statusReply == 3)), map(x => x?.length));
  amountPartial$ = this.#storeData.recipients$.pipe(filter(x => x != undefined), map(x => x!.filter(y => y.statusReply != 3)), map(x => x?.length));
  questionnarieParentDetails$ = toSignal(this.#storeData.questionnarieParentDetails$);
  isQuestionnarieParent$ = toSignal(this.#storeData.isQuestionnarieParent$);
  recipients$ = toSignal(this.#storeData.recipients$);
  recipientsGroupbyUsers$ = toSignal(this.#storeData.recipientsGroupbyUsers$);
  isFilterQuestionOpen = false;

  isFilterOpen = false;
  isFilterRecipientsOpen = false;
  readonly positonArea = [{
    originX: 'center',
    originY: 'bottom',
    overlayX: 'center',
    overlayY: 'top',
  }] as ConnectedPosition[];

  eReplyStatus = EReplyStatus;
  filter$ = toSignal(this.#storeData.currentFilter$);
  recipientsToFilterId$ = toSignal(this.#storeData.recipientsToFilterId$);

  constructor() {
    effect(() => {
      console.log('[Toolbar] selected userId:', this.recipientsToFilterId$());
    });

    effect(() => {
      console.log('[Toolbar] filter options:', this.filterFieldSubmissionOptions$?.() ?? this.filterFieldAnswersData$());
    });

    effect(() => {
      console.log('[Toolbar] selected recipientIdToFilter:', this.recipientIdToFilter$?.());
    });
  }

  filterBySubmission(recipientId: number | undefined) {
    console.log('[Toolbar] clicked submission recipientId:', recipientId);
    this.#storeData.updateRecipientIdToFilter(recipientId);
    this.isFilterQuestionOpen = false;
  }


  filterByStatusReply(status: EReplyStatus | undefined) {
    this.#storeData.updateCurrentFilter(status)
    this.isFilterOpen = false;
  }
  filterByRecipient(id?: number) {
    this.#storeData.updateCurrentRecipientIdToFilter(id);
    this.isFilterRecipientsOpen = false;
  }
  toggle(bool: boolean) {
    this.#storeData.updateshowComparison(bool)
  }

  filterByQuestion(questionId: number | undefined) {
    this.#storeData.updateSelectedQuestionId(questionId);
    this.isFilterQuestionOpen = false;
  }
  selectedQuestionId$ = toSignal(this.#storeData.selectedQuestionId$);
  // filterByFilterFieldValue(value: string | number | undefined) {
  //   this.#storeData.updateSelectedFilterFieldValue(value);
  //   this.isFilterQuestionOpen = false;
  // }
}